import {isApiException} from '@dms/api/utils';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

const PERMISSION_ERROR_CODE = 'ACL-FE-ER-0001';

/**
 * @about Detect whether a metada API error is an ACL/permission error
 * (the user does not have the required permission for the action).
 */
export function isPermissionError(error: ApiError) {
  if (!isFetchBaseQueryError(error) || !isApiException(error.data)) {
    return false;
  }

  return Array.isArray(error.data.errors)
    ? error.data.errors.some((item) => item?.code === PERMISSION_ERROR_CODE)
    : false;
}
